import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import APIs from "../../APIs";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [paymentStatus, setPaymentStatus] = useState("processing"); // "success" | "failed" | "processing"
  const [quote, setQuote] = useState(null);
  const [stripeResponse, setStripeResponse] = useState(null);

  const quoteId = sessionStorage.getItem("currentQuoteId");
  const stripePayId = sessionStorage.getItem("stripePayId");
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const userId = userData?.user_id;


  console.log('stripePayId',stripePayId);
  console.log('paymentStatus',paymentStatus);
  console.log('quote => ',quote);
  console.log('stripeResponse-> ',stripeResponse);
  console.log('quoteId-> ',quoteId);


  // ✅ 1️⃣ Fetch quote
  useEffect(() => {
    const fetchQuote = async () => {
      try {
        if (!quoteId) return setPaymentStatus("failed");
        const res = await APIs.post("quote/getQuoteById", { quote_id: quoteId });
        setQuote(res.data?.data || null);
      } catch (err) {
        console.error("Error fetching quote:", err);
        setPaymentStatus("failed");
      }
    };
    fetchQuote();
  }, [quoteId]);

  // ✅ 2️⃣ Verify Stripe session and process payment
  useEffect(() => {
    const session_id = searchParams.get("session_id");
    if (!session_id || !quote) return;

    const verifyStripeAndProcess = async () => {
      try {
        const res = await APIs.post("payment/verifyStripeSession", { session_id });
        const stripeData = res.data?.data || {};
        console.log('Full Stripe response:', {
          status: stripeData.status,
          fullResponse: stripeData,
          rawResponse: res.data
        });
        
        setStripeResponse(stripeData);
        
        // Don't call payment transaction here - let the separate useEffect handle it
        if (!["paid", "success", "succeeded"].includes(stripeData.status?.toLowerCase())) {
          console.error('Payment failed - status:', stripeData.status);
          setPaymentStatus("failed");
        }
      } catch (err) {
        console.error("Stripe verification error:", {
          message: err.message,
          response: err.response?.data,
          error: err
        });
        setPaymentStatus("failed");
      }
    };

    verifyStripeAndProcess();
  }, [searchParams, quote]);

  // ✅ 2.5️⃣ Process payment transaction when stripeResponse is available
  useEffect(() => {
    if (!stripeResponse || !quote) return;
    
    if (["paid", "success", "succeeded"].includes(stripeResponse.status?.toLowerCase())) {
      callPaymentTransaction();
    }
  }, [stripeResponse, quote]);

  // ✅ 3️⃣ Dynamic Payment Transaction Handler
  const callPaymentTransaction = async () => {
    try {
      console.log('stripeResponse in callPaymentTransaction:', stripeResponse);
      console.log('quote in callPaymentTransaction:', quote);
      
      if (!quote || !stripeResponse) {
        console.error('Missing required data for payment transaction:', {
          hasQuote: !!quote,
          hasStripeResponse: !!stripeResponse,
          stripePaymentIntentId: stripeResponse?.payment_intent?.id
        });
        return setPaymentStatus("failed");
      }

      // Use payment_intent.id if available, otherwise fall back to other IDs
      const paymentId = stripeResponse.payment_intent?.id || 
                       stripeResponse.id || 
                       stripePayId || 
                       `stripe_${Date.now()}`;

      const payload = {
        user_id: userId,
        shipment_id: quote?.shipment_id,
        payment_method: "Card",
        status: "Success",
        stripe_pay_id: paymentId,
        payment_date: new Date(),
        quote_id: quoteId,
      };

      console.log('Payment transaction payload:', payload);
      console.log('Payload keys:', Object.keys(payload));
      console.log('Payload values:', Object.values(payload));
      console.log('stripe_pay_id specifically:', payload.stripe_pay_id);

      // 🔁 Decide which API to call based on shipment status
      const apiEndpoint =
        quote.shipment?.status !== "Booked"
          ? "payment/addPaymentTransaction"
          : "payment/addPaymentTransactionAfterBooking";

      console.log('Using API endpoint:', apiEndpoint);

      const res = await APIs.post(apiEndpoint, payload);

      console.log("Payment transaction response:", res.data);

      if (res.data?.status?.toLowerCase() === "success") {
        setPaymentStatus("success");
      } else {
        console.error('Payment transaction failed:', res.data);
        setPaymentStatus("failed");
      }
    } catch (err) {
      console.error("Payment API error:", {
        message: err.message,
        response: err.response?.data,
        error: err
      });
      setPaymentStatus("failed");
    }
  };

  // ✅ 4️⃣ Button handlers
  const handleDashboardClick = () => {
    sessionStorage.removeItem("currentQuoteId");
    sessionStorage.removeItem("stripePayId");
    navigate("/Dashboard");
  };

  const handleTryAgain = () => {
    sessionStorage.removeItem("currentQuoteId");
    sessionStorage.removeItem("stripePayId");
    navigate(`/quotationdetails/${quote?.quote_id}`);
  };

  // ✅ 5️⃣ Render UI
  return (
    <div className="text-center my-5">
      {/* 🟢 SUCCESS MODAL */}
      {paymentStatus === "success" && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img
                  src="/images/sucess.jpg"
                  className="img-fluid sucess-img"
                  alt="success"
                />
                <h5 className="fw-bold">Payment Successful!</h5>
                <p className="mb-2">
                  Your booking and payment have been processed successfully.
                </p>
                <button
                  className="btn btn-success mt-3"
                  onClick={handleDashboardClick}
                >
                  Go to Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 🔴 FAILED MODAL */}
      {paymentStatus === "failed" && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-danger">
              <div className="modal-body text-center">
                <img
                  src="/images/payment_fail.png"
                  className="img-fluid sucess-img"
                  alt="payment failed"
                />
                <h5 className="text-danger fw-bold">Payment Failed</h5>
                <p className="mb-2">
                  Unfortunately, your booking or payment could not be processed.
                </p>
                <div className="d-flex justify-content-center gap-3 mt-3">
                  <button
                    className="btn btn-secondary"
                    onClick={handleTryAgain}
                    style={{ background: "#f21f1fff", color: "#fff" }}
                  >
                    Try Again
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={handleDashboardClick}
                  >
                    Go to Dashboard
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentSuccess;
